var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modal-container" },
    [
      _c(
        "form-wrapper",
        { staticClass: "modal-form", attrs: { validator: _vm.$v.rateDetail } },
        [
          _c("header", { staticClass: "modal-header" }, [
            _c(
              "div",
              { staticClass: "modal-header__right" },
              [
                _c(
                  "md-button",
                  {
                    staticClass: "md-simple md-just-icon md-round",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.$modal.hide($event)
                      },
                    },
                  },
                  [_c("md-icon", [_vm._v("clear")])],
                  1
                ),
              ],
              1
            ),
          ]),
          _c("section", { staticClass: "modal-section" }, [
            _c(
              "div",
              { staticClass: "section-override" },
              [
                _c(
                  "md-switch",
                  {
                    model: {
                      value: _vm.rateDetail.overrideRule,
                      callback: function ($$v) {
                        _vm.$set(_vm.rateDetail, "overrideRule", $$v)
                      },
                      expression: "rateDetail.overrideRule",
                    },
                  },
                  [_vm._v("\n                   Override\n                ")]
                ),
              ],
              1
            ),
            _c("div", { staticClass: "section-heading" }, [
              _c("span", { staticClass: "section-heading__badge" }, [
                _vm._v("Timeframe"),
              ]),
              _c("p", { staticClass: "section-heading__copy" }, [
                _vm._v("Choose when this surcharge is active."),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "section-card section-card--wide" },
              [
                _c("rule-valid-days", {
                  ref: "ruleValidDays",
                  attrs: {
                    "current-days": _vm.rateDetail.validForWeekDays,
                    "from-date": _vm.rateDetail.validFromDate,
                    "to-date": _vm.rateDetail.validToDate,
                  },
                  on: { daysSelected: _vm.handleDaysSeleceted },
                }),
              ],
              1
            ),
          ]),
          _c("section", { staticClass: "modal-section" }, [
            _c("div", { staticClass: "section-heading" }, [
              _c("span", { staticClass: "section-heading__badge" }, [
                _vm._v("Details"),
              ]),
              _c("p", { staticClass: "section-heading__copy" }, [
                _vm._v("Name the surcharge and define how it is calculated."),
              ]),
            ]),
            _c("div", { staticClass: "section-card section-card--compact" }, [
              _c("div", { staticClass: "charging-grid" }, [
                _c("div", { staticClass: "charging-group" }, [
                  _c("h5", { staticClass: "charging-group__title" }, [
                    _vm._v("Descriptor"),
                  ]),
                  _c("p", { staticClass: "charging-group__hint" }, [
                    _vm._v("Visible name when the surcharge is applied."),
                  ]),
                  _c(
                    "div",
                    { staticClass: "field-pair" },
                    [
                      _c(
                        "form-group",
                        { attrs: { name: "surchargeName", label: "Name" } },
                        [
                          _c("md-input", {
                            model: {
                              value: _vm.rateDetail.surchargeName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.rateDetail,
                                  "surchargeName",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "rateDetail.surchargeName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "charging-separator" }),
                _c("div", { staticClass: "charging-group" }, [
                  _c("h5", { staticClass: "charging-group__title" }, [
                    _vm._v("Amount"),
                  ]),
                  _c("p", { staticClass: "charging-group__hint" }, [
                    _vm._v("Specify percentage or flat rate."),
                  ]),
                  _c(
                    "div",
                    { staticClass: "field-pair" },
                    [
                      _c(
                        "form-group",
                        {
                          attrs: {
                            name: "surchargePercentage",
                            label: "Percentage",
                          },
                        },
                        [
                          _vm.$_nullChecker(_vm.rateDetail.surchargePercentage)
                            ? _c("rule-operator", {
                                attrs: {
                                  value:
                                    _vm.rateDetail.surchargePercentage.operator,
                                },
                                model: {
                                  value:
                                    _vm.rateDetail.surchargePercentage.operator,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.rateDetail.surchargePercentage,
                                      "operator",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "rateDetail.surchargePercentage.operator",
                                },
                              })
                            : _vm._e(),
                          _c("md-input", {
                            model: {
                              value: _vm.rateDetail.surchargePercentage.value,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.rateDetail.surchargePercentage,
                                  "value",
                                  _vm._n($$v)
                                )
                              },
                              expression:
                                "rateDetail.surchargePercentage.value",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "form-group",
                        {
                          attrs: {
                            name: "surchargeFlatRate",
                            label: "Flat Rate",
                          },
                        },
                        [
                          _vm.$_nullChecker(_vm.rateDetail.surchargeFlatRate)
                            ? _c("rule-operator", {
                                attrs: {
                                  value:
                                    _vm.rateDetail.surchargeFlatRate.operator,
                                },
                                model: {
                                  value:
                                    _vm.rateDetail.surchargeFlatRate.operator,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.rateDetail.surchargeFlatRate,
                                      "operator",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "rateDetail.surchargeFlatRate.operator",
                                },
                              })
                            : _vm._e(),
                          _c("md-input", {
                            attrs: { type: "number" },
                            model: {
                              value: _vm.rateDetail.surchargeFlatRate.value,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.rateDetail.surchargeFlatRate,
                                  "value",
                                  _vm._n($$v)
                                )
                              },
                              expression: "rateDetail.surchargeFlatRate.value",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
          ]),
          _c("footer", { staticClass: "modal-footer" }, [
            _c(
              "div",
              { staticClass: "modal-footer__actions" },
              [
                _c(
                  "md-button",
                  {
                    staticClass: "md-default dialog-button",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.$modal.hide($event)
                      },
                    },
                  },
                  [_vm._v("Cancel")]
                ),
                _c(
                  "md-button",
                  {
                    staticClass: "md-primary dialog-button",
                    on: {
                      click: function ($event) {
                        return _vm.create()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.isUpdate ? "Update" : "Create") +
                        "\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }